module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/apple-icon-152x152-70dd3f9e5bc1fc974ba63733acee9001.png";